import { useColorScheme } from '@mui/joy';
import { useMemo } from 'react';

import { useAuthUser } from 'auth/hooks';
import { LogoType } from 'core/enums';
import { useGetLogoPaths } from 'core/hooks';
import { IMenuItem } from 'core/types';
import { logoHomePath } from 'home/routes/routePaths';
import { hasPermission } from 'router/utils';
import { ModeType } from 'theme/enums';

import Logo from './Logo';
import { MenuItem } from './MenuItem';
import { leftMenuStructure } from './structure';
import { LogoWrapper, MenuItemWrapper, Wrapper } from './style';

const LeftMenu = () => {
  const { mode } = useColorScheme();

  const { logoPaths } = useGetLogoPaths();
  const { user } = useAuthUser();

  const resources = useMemo(() => user?.resources, [user]);

  const logoPath = useMemo(() => {
    const isDarkMode = mode === ModeType.DARK;
    const primaryLogo = isDarkMode ? LogoType.HEADER : LogoType.HEADER_ON_LIGHT_BG;

    return logoPaths?.[primaryLogo] || logoPaths?.[LogoType.SMALL];
  }, [logoPaths, mode]);

  return (
    <Wrapper>
      <LogoWrapper>
        <Logo key={logoPath} url={logoHomePath()} path={logoPath} />
      </LogoWrapper>

      <MenuItemWrapper>
        {leftMenuStructure(resources, user).map(
          (item: IMenuItem) =>
            hasPermission(item?.permissions, resources) &&
            !item?.hide && (
              <MenuItem
                key={item.name}
                text={item.name}
                icon={item?.icon}
                endDecorator={item?.endDecorator}
                subItems={item?.subMenuItems}
                url={item?.url}
                onClick={item?.onClick}
                matchedPath={item?.matchedPath}
              />
            )
        )}
      </MenuItemWrapper>
    </Wrapper>
  );
};

export default LeftMenu;
